// Generated by Claude Code
import { WorkRequestsPage } from '#components/domain/operations/work-requests/work-requests-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionAction, PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/work-requests/')({
  component: RouteComponent,
  staticData: {
    title: 'Work Requests',
  },
  // Other params (the `slice` an Analysis link adds) pass through untouched; `useListSlice` reads them.
  validateSearch: (search: Record<string, unknown>): { assetId?: string; view?: 'history' } & Record<string, unknown> => ({
    ...search,
    // Asset-QR create deep-link (a logged-in user scanning an asset QR): opens the
    // create drawer with the asset pre-filled. Consumed once on mount, then cleared.
    assetId: (search.assetId as string) ?? undefined,
    // App-mode WR home toggle: absent = create-first home; `history` = the card list.
    view: search.view === 'history' ? 'history' : undefined,
  }),
})

function RouteComponent() {
  return (
    <PermissionGuard
      // Viewable with any read grant (full or limited slot) OR with CREATE:
      // requesters without read access still enter to submit their requests.
      permissions={[
        ...readAnyGroups(PermissionService.WORK_ORDER_REQUESTS),
        [[PermissionService.WORK_ORDER_REQUESTS, PermissionAction.CREATE]],
      ]}
      redirectOnNotAuthorized
    >
      <WorkRequestsPage />
    </PermissionGuard>
  )
}
